import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { GetCompanyList } from "../Responses/GetCompanyList";

export async function getCompanyList() {
	let response = await getAPIResponse("/v1/company-list");
	if (response === null) {
		return null;
	}
	let getCompanyList = GetCompanyList.createFromResponseData(response);
	return getCompanyList;
}
